export default function noCache () {
  return true;
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/caching/noCache.js